import { env } from "@/env.cjs";

export const MAX_FILE_SIZE = 10 * 1048576;
// 1 mb = 1048576 bytes
export const ACCEPTED_FILE_TYPES_DEFAULT = [
	"application/pdf",
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	"application/msword",
];

export const ACCEPTED_FILE_EXTENSIONS_DEFAULT = [".pdf", ".docx", ".doc"];
export const ACCEPT_ATTRIBUTE_DEFAULT = ACCEPTED_FILE_EXTENSIONS_DEFAULT.join(",").toLowerCase();

export const ACCEPTED_FILE_TYPES_FOR_PROJECT_FILES = [
	"application/pdf",
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	"application/msword",
	"image/jpeg",
	"image/png",
	"image/webp",
	"application/vnd.ms-excel",
	"text/csv",
	"text/plain",
	"text/rtf",
];

export const ACCEPTED_FILE_EXTENSIONS_FOR_PROJECT_FILES = [
	".pdf",
	".docx",
	".doc",
	".jpeg",
	".jpg",
	".png",
	".webp",
	".xls",
	".csv",
	".txt",
	".rtf",
];

export const ACCEPT_ATTRIBUTE_FOR_PROJECT_FILES = ACCEPTED_FILE_EXTENSIONS_FOR_PROJECT_FILES.join(",").toLowerCase();

export const ACCEPTED_FILE_TYPES_FOR_PUBLIC_COMMENT_FILES = [
	"application/pdf",
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	"application/msword",
	"application/vnd.ms-excel",
	"text/csv",
	"text/plain",
	"text/rtf",
];

export const ACCEPTED_FILE_EXTENSIONS_FOR_PUBLIC_COMMENT_FILES = [
	".pdf",
	".docx",
	".doc",
	".xls",
	".csv",
	".txt",
	".rtf",
];

export const ACCEPT_ATTRIBUTE_FOR_PUBLIC_COMMENT_FILES =
	ACCEPTED_FILE_EXTENSIONS_FOR_PUBLIC_COMMENT_FILES.join(",").toLowerCase();

export const ACCEPTED_FILE_TYPES_FOR_VALIDATION_FILES = [
	"application/pdf",
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	"application/msword",
	"image/jpeg",
	"image/png",
	"image/webp",
	"application/vnd.ms-excel",
	"text/csv",
	"text/plain",
	"text/rtf",
];

export const ACCEPTED_FILE_EXTENSIONS_FOR_VALIDATION_FILES = [
	".pdf",
	".docx",
	".doc",
	".jpeg",
	".jpg",
	".png",
	".webp",
	".xls",
	".csv",
	".txt",
	".rtf",
];

export const RICH_TEXT_IMAGE_MAX_FILE_SIZE = 5 * 1048576;
export const ACCEPTED_FILE_TYPES_FOR_RICH_TEXT_IMAGES = ["image/jpeg", "image/png", "image/webp"];

export const ACCEPT_ATTRIBUTE_FOR_VALIDATION_FILES =
	ACCEPTED_FILE_EXTENSIONS_FOR_VALIDATION_FILES.join(",").toLowerCase();

export const DEFAULT_ROUND_LENGTH_IN_DAYS = env.NEXT_PUBLIC_DEFAULT_ROUND_LENGTH_IN_DAYS;

export const CREDITS_TRANSACTION_DETAILS_LINK = env.NEXT_PUBLIC_CREDITS_TRANSACTION_DETAILS_LINK;

export const NEXT_PUBLIC_ACTIVITY_FETCH_WINDOW_IN_DAYS = env.NEXT_PUBLIC_ACTIVITY_FETCH_WINDOW_IN_DAYS;

export const VALIDATION_REPORT_TEMPLATE_LINK = env.NEXT_PUBLIC_VALIDATION_REPORT_TEMPLATE_LINK;

export const NEXT_PUBLIC_PUBLIC_COMMENTARY_JOTFORM_LINK = env.NEXT_PUBLIC_PUBLIC_COMMENTARY_JOTFORM_LINK;
export const NEXT_PUBLIC_PROJECTS_PUBLIC_COMMENTARY_JOTFORM_LINK =
	env.NEXT_PUBLIC_PROJECTS_PUBLIC_COMMENTARY_JOTFORM_LINK;
export const TINYMCE_API_KEY = env.NEXT_PUBLIC_TINYMCE_API_KEY;

export const VALIDATION_FILES_MAX_FILE_SIZE = 45 * 1048576;

export const PERMANENT_ANONIMITY_VALIDATORS_ID_SET = new Set(env.NEXT_PUBLIC_PERMANENT_ANONIMITY_VALIDATOR_IDS ?? []);
export const VALIDATOR_IDS_SET_WITH_PRIVATE_REPORTS = new Set(env.NEXT_PUBLIC_VALIDATOR_IDS_WITH_PRIVATE_REPORTS ?? []);
export const CONVERTED_MTD_IDS_SET = new Set(env.NEXT_PUBLIC_CONVERTED_MTD_IDS ?? []);

export const OCP_METHODOLOGY_PLATFORM_UPDATE_EXPLANATION_LINK =
	"https://open-carbon-protocol.gitbook.io/ocp-methodology-requirements/context/version-history/methodology-tool-upgrades";

export const OCP_MTD_PUBLIC_STATS = {
	publishedCount: env.NEXT_PUBLIC_OCP_MTD_PUBLISHED_COUNT,
	publicCommentaryCount: env.NEXT_PUBLIC_OCP_MTD_PUBLIC_COMMENTARY_COUNT,
	inReviewCount: env.NEXT_PUBLIC_OCP_MTD_IN_REVIEW_COUNT,
	underDevelopmentCount: env.NEXT_PUBLIC_OCP_MTD_UNDER_DEVELOPMENT_COUNT,
	upcomingCount: env.NEXT_PUBLIC_OCP_MTD_UPCOMING_COUNT,
};

export const OCP_PROJECTS_PUBLIC_STATS = {
	activeCount: env.NEXT_PUBLIC_OCP_PROJECTS_ACTIVE_COUNT,
	inValidationCount: env.NEXT_PUBLIC_OCP_PROJECTS_IN_VALIDATION_COUNT,
};

export const FORCEFULLY_HIDDEN_PUBLIC_COMMENTARY_MTD_IDS = new Set(
	env.NEXT_PUBLIC_FORCEFULLY_HIDDEN_PUBLIC_COMMENTARY_MTD_IDS ?? [],
);
